import type { ExternalMCPOAuthAuthorization, ExternalMCPServer, ExternalMCPServerInput } from "@/schema"

import { apiContextFetch, ApiRequestError, type ApiContext } from "../base"

interface ExternalMCPServersResponse {
  external_mcp_servers: ExternalMCPServer[]
}

export function isExternalMCPManualAuthenticationRequired(error: unknown) {
  if (!(error instanceof ApiRequestError)) return false

  const body = error.responseBody
  return (
    typeof body === "object" &&
    body !== null &&
    "authentication_setup" in body &&
    body.authentication_setup === "authorization_header"
  )
}

export async function fetchExternalMCPServers(context: ApiContext, chatThreadId?: string) {
  const query = chatThreadId ? `?chat_thread_id=${encodeURIComponent(chatThreadId)}` : ""
  const response = await apiContextFetch<ExternalMCPServersResponse>(context, `external_mcp_servers${query}`)
  return response.external_mcp_servers
}

export function authorizeExternalMCPOAuth(context: ApiContext, id: string, returnUri: string) {
  return apiContextFetch<ExternalMCPOAuthAuthorization>(context, `external_mcp_servers/${id}/oauth_authorization`, {
    method: "POST",
    body: JSON.stringify({ return_uri: returnUri }),
  })
}

export function createExternalMCPServer(context: ApiContext, input: ExternalMCPServerInput) {
  return apiContextFetch<ExternalMCPServer>(context, "external_mcp_servers", {
    method: "POST",
    body: JSON.stringify({ external_mcp_server: input }),
  })
}

export function updateExternalMCPServer(context: ApiContext, id: string, input: Partial<ExternalMCPServerInput>) {
  return apiContextFetch<ExternalMCPServer>(context, `external_mcp_servers/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ external_mcp_server: input }),
  })
}

export function deleteExternalMCPServer(context: ApiContext, id: string) {
  return apiContextFetch<Record<string, never>>(context, `external_mcp_servers/${id}`, {
    method: "DELETE",
  })
}
